<template>
    <div class="tw-animate-pulse tw-snap-center tw-flex tw-flex-col tw-group tw-py-3 tw-w-full">
        <div class="tw-flex tw-flex-row tw-items-center">
            <!-- Thumbnail Image -->
            <div class="tw-flex tw-flex-col tw-items-start tw-p-0 tw-isolate tw-h-[120px] tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-[8px] tw-w-1/3 lg:tw-w-full">
            </div>
            <!-- Text Section -->
            <div class="tw-flex tw-flex-col tw-w-2/3 tw-ml-2 lg:tw-w-full lg:tw-ml-0">
                <div class="tw-flex tw-items-start tw-p-0 tw-gap-[12px] tw-w-full tw-h-[16px] tw-my-1">
                    <div class="tw-w-9/10 tw-w-full tw-h-[16px] tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-[40px]">
                    </div>
                    <div class="tw-w-[16px] tw-h-[16px] tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-[40px]">
                    </div>
                </div>
                <div class="tw-w-full tw-h-[16px] tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-[40px]"></div>
            </div>
        </div>
    </div>
</template>
<script setup>
</script>
